package org.abhranilnxt.portfolio.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.abhranilnxt.portfolio.models.Section
import org.abhranilnxt.portfolio.models.Theme
import org.abhranilnxt.portfolio.styles.LogoStyle
import org.abhranilnxt.portfolio.styles.NavigationItemStyle
import org.abhranilnxt.portfolio.util.Constants.FONT_FAMILY
import org.abhranilnxt.portfolio.util.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun Header(onMenuClicked: () -> Unit) {
    val breakpoint = rememberBreakpoint()
    Row(
        modifier = Modifier
            .fillMaxWidth(if(breakpoint > Breakpoint.MD) 80.percent else 90.percent)
            .margin(topBottom = 40.px),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        LeftHeader(breakpoint = breakpoint,
            onMenuClicked = onMenuClicked)
        if(breakpoint > Breakpoint.MD) {
            RightHeader()
        }
    }
}

@Composable
fun LeftHeader(breakpoint: Breakpoint,
               onMenuClicked: () -> Unit) {
    Row(
        verticalAlignment = Alignment.CenterVertically
    ) {
        if(breakpoint <= Breakpoint.MD) {
            FaBars(
                modifier = Modifier.margin(right = if(breakpoint <= Breakpoint.SM) 0.px else 5.px)
                    .onClick {
                        onMenuClicked()
                    },
                size = IconSize.LG
            )
        }
        if(breakpoint <= Breakpoint.SM) {
            Image(
                modifier = LogoStyle.toModifier().size(80.px),
                src = Res.Images.logo,
                description = "logo image"
            )
        }
        else {
            Image(
                modifier = LogoStyle.toModifier(),
                src = Res.Images.logo,
                description = "logo image"
            )
        }
    }
}

@Composable
fun RightHeader() {
    Row(
       modifier = Modifier
           .fillMaxWidth()
           .borderRadius(r = 50.px)
           .backgroundColor(Theme.LighterGray.rgb)
           .padding(all = 20.px),
        horizontalArrangement = Arrangement.End
    ) {
        Section.entries.toTypedArray().take(6).forEach { section ->
            Link(
                modifier = NavigationItemStyle.toModifier().margin(right = 30.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(14.px)
                    .fontWeight(FontWeight.SemiBold)
                    .textDecorationLine(TextDecorationLine.None),
                path = section.path,
                text = section.title
            )
        }
    }
}